import { createApp } from 'vue'
import { createPinia } from 'pinia'
import ElementPlus from 'element-plus'
import App from './App.vue'
import router from './router'
import { i18n } from './i18n'
import './assets/styles/main.css'

/**
 * Punto de entrada.
 *
 * ElementPlus se registra completo: el panel usa una parte grande de la
 * librería (tablas, formularios, diálogos, popovers, cajones) y el bundle se
 * separa en su propio chunk en `vite.config.js`. Si el peso llegara a molestar,
 * el cambio a importación bajo demanda es local a este archivo.
 */
const app = createApp(App)

app.use(createPinia())
app.use(i18n)
app.use(ElementPlus)
app.use(router)

app.config.errorHandler = (error, _instance, info) => {
  // Último recinto: un error de render no puede dejar la pantalla en blanco sin rastro.
  console.error('[iris] error no controlado', info, error)
}

app.mount('#app')
